import { render, staticRenderFns } from "./navheader.vue?vue&type=template&id=0ff33502"
import script from "./navheader.vue?vue&type=script&lang=js"
export * from "./navheader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports